import React from 'react';
import { css, cx } from '@linaria/core';

const tableRowClassname = css`
  &:nth-child(odd) {
    background-color: #f8f8f8;
  }
  
  thead &:nth-child(odd) {
    background-color: white;
  }

  &:nth-child(even) {
    background-color: white;
  }

  &:nth-child(even) button {
    background-color: transparent;
  }

  &:nth-child(even) button:hover {
    background-color: rgba(0, 0, 0, 0.09);
  }

`;

export const Table = ({ children, style: overwriteStyle, ...attr }) => {
  const style = {
    width: '100%',
    borderCollapse: 'collapse',
  };
  return (
    <table className="bambuser-table" style={{ ...style, ...overwriteStyle }} {...attr}>
      {children}
    </table>
  );
};

export const TableHead = ({ children, style: overwriteStyle, ...attr }) => {
  const style = {};
  return (
    <thead style={{ ...style, ...overwriteStyle }} {...attr}>
      {children}
    </thead>
  );
};

export const TableBody = ({ children, style: overwriteStyle, ...attr }) => {
  const style = {};
  return (
    <tbody style={{ ...style, ...overwriteStyle }} {...attr}>
      {children}
    </tbody>
  );
};

export const TableFooter = ({ children, style: overwriteStyle, ...attr }) => {
  const style = {};
  return (
    <tfoot style={{ ...style, ...overwriteStyle }} {...attr}>
      {children}
    </tfoot>
  );
};

export const TableHeader = ({ children, style: overwriteStyle, ...attr }) => {
  const style = {};
  return (
    <th style={{ ...style, ...overwriteStyle }} {...attr}>
      {children}
    </th>
  );
};

export const TableData = ({ children, style: overwriteStyle, ...attr }) => {
  const style = {
    padding: 0,
  };
  return (
    <td style={{ ...style, ...overwriteStyle }} {...attr}>
      {children}
    </td>
  );
};

export const TableRow = ({ children, style: overwriteStyle, className, ...attr }) => {
  return (
    <tr style={overwriteStyle} className={cx(tableRowClassname, className)} {...attr}>
      {children}
    </tr>
  );
};
